import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { SearchSuggestionsService } from '~src/spacesPlatform/services/SearchSuggestionsService';

import { AddGroupsToGroupSetDialogBody, AddGroupsToGroupSetDialogProps, AddGroupsToGroupSetDialogState } from '../../components/AddGroupsToGroupSetDialog';
import { GroupSets } from '../../GroupSets';
import { IGroupSetGroupInfo, IGroupSetInfo } from '../../models/IGroupSetInfo';
import { IAddGroupToGroupSetResult } from '../../serverApi/requests/AddGroupToGroupSetRequest';

const initialDialogState: AddGroupsToGroupSetDialogState = {
    selectedGroupIds: [],
    selectedIGroupInfoSet: new Set()
};

export function isSubmitEnabled(state: AddGroupsToGroupSetDialogState): boolean {
    return state.selectedGroupIds.length === 0;
}

export async function showAddGroupsToGroupSetDialog(groupSet: IGroupSetInfo): Promise<IResult> {
    const groupsInGroupSet = getExistingGroupsInGroupSet(groupSet);

    this.initialBodyProps = { groupSet: groupSet };
    const title = Messages.addGroups();
    const actionDisabled = (props: AddGroupsToGroupSetDialogProps, state: AddGroupsToGroupSetDialogState) => {
        return isSubmitEnabled(state);
    };

    const dialogInstance = openReactActionDialog<AddGroupsToGroupSetDialogProps, AddGroupsToGroupSetDialogState, IResult>({
        actionName: Messages.addGroupToGroupSetDialogSubmit(),
        action: addGroupsToGroupSetAction,
        actionDisabled,
        bodyComponent: AddGroupsToGroupSetDialogBody,
        dialogWidth: TabDialogWidth.width650px,
        dismissDialogOnActionFailed: false,
        initialBodyProps: {
            groupSet: groupSet,
            getQuery: SearchSuggestionsService.groups,
            inGroupSetGroupsList: groupsInGroupSet
        },
        initialDialogState,
        title,
    });
    return Promise.resolve(dialogInstance.result);
}

function getExistingGroupsInGroupSet(groupSet: IGroupSetInfo): IGroupSetGroupInfo[] {
    if (groupSet.groupCount > 0) {
        const groups = groupSet.group;
        return groups;
    }
    return [];
}

async function addGroupsToGroupSetAction(
    props: AddGroupsToGroupSetDialogProps,
    dialogState: AddGroupsToGroupSetDialogState,
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<AddGroupsToGroupSetDialogState>>): Promise<any> {
        const result = await GroupSets.addGroupsToGroupSet(dialogState.selectedIGroupInfoSet, props.groupSet.id);
        notify(result);
        return Promise.resolve();
}

function notify(
    result: IAddGroupToGroupSetResult) {
    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = errorMessageFor(result.errors[0].code);
      if (errorMsg) {
        ToasterService.instance.pop({ type: ToastType.Error, text: errorMsg });
        return Promise.reject();
      } else {
        ToasterService.instance.pop({ type: ToastType.Error, text: Messages.addGroupsToGroupSetErrorMsg() });
        return Promise.reject();
      }
    } else {
        let successCount = result.groups.length;
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.groupsAddedToGroupSetSuccessMsg(
        {
            ITEM_COUNT: successCount,
            ITEM_COUNT_LOC: L10n.localizedCount(successCount)
        })
    });
    }
    return Promise.resolve(result);
}

function errorMessageFor(errorCode: number): string {
    switch (errorCode) {
      default:
        return undefined;
    }
}

export const AddGroupsToGroupSetAction = {
    showAddGroupsToGroupSetDialog,
    notify
};

export type AddGroupsToGroupSetAction = typeof AddGroupsToGroupSetAction;